import { isGlobalFeatureEnabled } from "./isFeatureEnabled";

export default function isAddinMultiAccountEnabled(): boolean {
    //Addin for secondary accounts are enabled if the feature flag is enabled for the primary mailbox
    return isGlobalFeatureEnabled("mos-multiAccount");
}
